import {
    ArrowUpRight,
    Checks,
    ClockCounterClockwise,
    Copy,
    Funnel,
    GridFour,
    Star,
    Table,
    UserPlus,
    X,
} from "@phosphor-icons/react";
import React, { useEffect, useMemo, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import PageLoader from "../loader/PageLoader";
import { useQuery } from "@tanstack/react-query";
// import ManageRoom from "./ManageRoom";
import ManageRoom from "../Manage Room/ManageRoom";
import PendingAmountsModal from "../PendingAmountsModal/PendingAmountsModal";
import { formatINR } from "./Promotions/promoUtils";
import ConfirmPrice from "./ConfirmPrice";
import WebCheckin from "./WebCheckin";
import EarlyCheckin from "./EarlyCheckin";
import LateCheckout from "./LateCheckout";
import Dining from "./Dining";
import HouseKeeping from "./HouseKeeping";
import WakeUp from "./WakeUp";
import ConferenceRoom from "./ConferenceRoom";
import ExtendStay from "./ExtendStay";
import Custom from "./Custom";
import RestaurantTable from "./RestaurantTable";
import Wifi from "./Wifi";
import Checkout from "./Checkout";
import RoomChange from "./RoomChange";
import Spa from "./Spa";
import PastBookings from "./PastBookings";
import { useNavigate, Outlet } from "react-router-dom";
import axios from "axios";
import CheckOutModal from "../CheckOutModal/CheckOutModal";
import { baseURL } from "../../api/urlInstance";


import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import NotificationProvider from '../NotificationProvider';
import { formatHotel } from "../../api/hotelTime";
import RoomRequestsPanel, {
    activeComponentForType,
} from "./RoomRequestsPanel";
// Extend Day.js with the utc plugin
dayjs.extend(utc);

const Rooms = () => {
    const [openFilter, setOpenFilter] = useState(false);
    const [viewChanged, setViewChanged] = useState("grid");
    const [filteredData, setFilteredData] = useState([]);
    const [copiedId, setCopiedId] = useState(null);
    const [filters, setFilters] = useState({
        bookingNumber: "",
        roomNumber: "",
        pendingRequests: false,
        ongoingRequests: false,
    });
    const hotelId = localStorage.getItem("hotelId");
    const [openReq, setOpenReq] = useState(false);
    const [activeComponent, setActiveComponent] = useState(null);
    const [selectedRequest, setSelectedRequest] = useState(false);
    const [selectedBookedRoom, setSelectedBookedRoom] = useState(null);
    const [charges, setCharges] = useState(null);
    const [showAmounts, setShowAmounts] = useState(false);
    const [openPastBook, setOpenPastBook] = useState(false);
    const navigate = useNavigate();

    const fetchBookedRoomsAndRequests = async (hotelId) => {
        try {
            const [bookingsResponse, requestsResponse] = await Promise.all([
            axiosInstance.get(`/api/v1/hotels/${hotelId}/active-booked-rooms`),
            axiosInstance.get(`/api/v1/hotels/${hotelId}/active-requests`),
            ]);

            return {
            activeBookings: bookingsResponse?.data?.activeBookedRoomsMetadata || [],
            activeRequests: requestsResponse?.data?.data || [],
            };
        } catch (error) {
            // If any error occurs, return empty arrays
            return {
            activeBookings: [],
            activeRequests: [],
            };
        }
    };


    const { data, isLoading, isFetching, error } = useQuery({
        queryKey: ["activeRooms&activeBookedRooms", hotelId],
        queryFn: () => fetchBookedRoomsAndRequests(hotelId),
        refetchOnWindowFocus: true,
        staleTime: 5000,
        refetchInterval: 3000,  // Poll every 30 seconds (adjust as needed)
    });

    useEffect(() => {
        if (data) {
            // Apply initial filtering or transformation to data
            setFilteredData(data?.activeBookings || []); // You can modify this to apply a default filter if needed
        }
    }, [data]);

    const handleCopy = (text, id) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedId(id);
            setTimeout(() => setCopiedId(false), 2000); // Reset copied state after 2 seconds
        });
    };

    const handleItemClick = (booking) => {
        setSelectedBookedRoom(booking);
        setShowAmounts(false);
    };

    useEffect(() => {
        if (!selectedBookedRoom) {
            setCharges(null);
            return;
        }

        let active = true;

        axiosInstance
            .get(
                `/api/v1/hotels/${hotelId}/bookings/${selectedBookedRoom.booking_id}/booked-rooms/${selectedBookedRoom.booked_room_id}/charges`,
            )
            .then((response) => {
                if (active) {
                    setCharges(response.data);
                }
            })
            .catch(() => {
                if (active) {
                    setCharges(null);
                }
            });

        return () => {
            active = false;
        };
    }, [selectedBookedRoom, hotelId]);

    const applyFilter = () => {
        let filtered = data?.activeBookings || [];

        // For Booking Number,Room Number,Ongoing,Pending
        if (
            filters.bookingNumber &&
            filters.roomNumber &&
            filters.pendingRequests &&
            filters.ongoingRequests
        ) {
            // console.log("All");
            const roomNum = parseInt(filters.roomNumber, 10); // Fixed typo

            filtered = filtered.filter((d) => {
                if (
                    filters.bookingNumber === d.booked_room_id &&
                    roomNum === d.room_no &&
                    (d.Ongoing_requests > 0 || d.pending_requests > 0)
                ) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilteredData(filtered);
            setOpenFilter(false);
            return;
        }

        // For One Status
        if (
            filters.bookingNumber &&
            filters.roomNumber &&
            filters.pendingRequests
        ) {
            // console.log("All");
            const roomNum = parseInt(filters.roomNumber, 10); // Fixed typo

            filtered = filtered.filter((d) => {
                if (
                    filters.bookingNumber === d.booked_room_id &&
                    roomNum === d.room_no &&
                    d.pending_requests > 0
                ) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilteredData(filtered);
            setOpenFilter(false);
            return;
        }

        if (
            filters.bookingNumber &&
            filters.roomNumber &&
            filters.ongoingRequests
        ) {
            // console.log("All");
            const roomNum = parseInt(filters.roomNumber, 10); // Fixed typo

            filtered = filtered.filter((d) => {
                if (
                    filters.bookingNumber === d.booked_room_id &&
                    roomNum === d.room_no &&
                    d.Ongoing_requests > 0
                ) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilteredData(filtered);
            setOpenFilter(false);
            return;
        }

        // For Booking Number and Room Number
        if (filters.bookingNumber && filters.roomNumber) {
            const roomNum = parseInt(filters.roomNumber, 10); // Fixed typo

            filtered = filtered.filter((d) => {
                if (
                    filters.bookingNumber === d.booked_room_id &&
                    roomNum === d.room_no
                ) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilteredData(filtered);
            setOpenFilter(false);
            return;
        }

        // For Booking Id
        if (filters.bookingNumber) {
            filtered = filtered.filter((d) => {
                // console.log("Booking Number:", filters.bookingNumber);
                // console.log("Booking ID:", d.booking_id);
                return (
                    d.booked_room_id.toString() ===
                    filters.bookingNumber.toString()
                );
            });
        }

        // Filter by room number
        if (filters.roomNumber) {
            filtered = filtered.filter((d) => {
                const room = parseInt(filters.roomNumber, 10);
                if (d.room_no === room) {
                    // console.log("Here");
                    return true;
                } else {
                    return false;
                }
            });

            setFilteredData(filtered);
            setOpenFilter(false);
            return;
        }

        // Filter by pending requests
        if (filters.pendingRequests) {
            filtered = filtered.filter((d) => d.pending_requests > 0);
        }

        // Filter by ongoing requests
        if (filters.ongoingRequests) {
            filtered = filtered.filter((d) => d.Ongoing_requests > 0);
        }

        setFilteredData(filtered);
        // Narrowing the list can strand the open detail panel on a booking that is
        // no longer visible, leaving its actions pointing at something off-screen.
        setSelectedBookedRoom(null);
        setOpenFilter(false);
    };

    // Handle filter change
    const handleFilterChange = (e) => {
        const { name, value, checked, type } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    // Function to reset the filters
    const resetFilters = () => {
        setFilters({
            bookingNumber: "",
            roomNumber: "",
            pendingRequests: false,
            ongoingRequests: false,
        });
        setFilteredData(data?.activeBookings || []); // Reset to original data
        setSelectedBookedRoom(null);
        setOpenFilter(false);
    };

    const roomRequests = useMemo(
        () =>
            selectedBookedRoom
                ? (data?.activeRequests || []).filter(
                      (request) =>
                          request.room_number === selectedBookedRoom.room_no,
                  )
                : [],
        [data, selectedBookedRoom],
    );

    const handleOpenRequest = (request) => {
        setSelectedRequest({
            type: request.type,
            hotelId: request.hotel_id,
            bookingId: request.booking_id,
            bookedRoomId: request.booked_room_id,
            requestId: request.id,
            activeDriver: request.status,
            roomNumber: request.room_number,
            userId: request.user_id,
        });
        setOpenReq(true);
        setActiveComponent(activeComponentForType(request.type));
    };

    if (error) console.log("error occured", error);

    // Close Detail Button
    const handleCloseDetail = () => {
        setSelectedBookedRoom(null);
    };

    // Handle Manage Guest
    const handleManageGuest = (bookingId, roomId, e) => {
        e.stopPropagation();
        // console.log("Booking Details:", bookingId);

        // Construct the full URL based on your current location
        const url = `${window.location.origin}/dashboard/rooms/manage-guest/${bookingId}/${roomId}`;

        // Open the constructed URL in a new tab
        window.open(url, "_blank", "noopener,noreferrer");
    };

    // Handle Manage Room
    const handleManageRoom = (bookingId, roomId, e) => {
        const url = `${window.location.origin}/dashboard/rooms/manage-room/${bookingId}/${roomId}`;

        // Open the constructed URL in a new tab
        window.open(url, "_blank", "noopener,noreferrer");
    };

    // Handle CheckOut Button
    const handleCheckout = async (room) => {
        try {
            const response = await axiosInstance.put(
                `/api/v1/hotels/${hotelId}/bookings/${room.booking_id}/booked-rooms/${room.booked_room_id}`,
                {
                    payment_status: "SUCCESSFUL",
                },
            );

            // console.log(response.data);
        } catch (error) {
            console.error("error occured while making the checkout", error);
        }
    };



    // Open Rooms Modal
    const [guestData, setGuestData] = useState(null);
    const [generalData, setGeneralData] = useState(null);
    const [modalRoom, setModalRoom] = useState(false);  // Make sure modalRoom state exists
    const formatDateForInput = (date) => {
        return formatHotel(date, "YYYY-MM-DDTHH:mm");
    };
    
 
    
    const handleOpenManageRoomModal = async (bookingId, bookedRoomId) => {
        try {
            const storedToken = localStorage.getItem("token");
            const hotelId = localStorage.getItem("hotelId");
    
            const response = await axiosInstance.get(
                `/api/v1/hotels/${hotelId}/bookings/${bookingId}/booked-rooms/${bookedRoomId}`,
                {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                }
            );
    
            // console.log("Response for Booked Room: ", response.data);
    
            const guests = response?.data?.guests || [];
            const checkInDate = formatDateForInput(response?.data?.checkin_date || "");
            // console.log("Check In Date: ", checkInDate);
            // console.log("Check In Date: ", response?.data?.checkin_date);

            const checkOutDate = formatDateForInput(response?.data?.checkout_date || "");
            
            // console.log("Check Out Date: ", response?.data?.checkout_date);
            
            const numberOfGuests = response?.data?.number_of_guests || "";
            const roomNumber = response?.data?.room_number || "";
   
            // return;
            // Set guest data as an array
            setGuestData(guests);
    
            // Set general data as an object
            setGeneralData({
                checkInDate,
                checkOutDate,
                numberOfGuests,
                roomNumber,
                bookingId,
                bookedRoomId
            });
    
            // After data is set, open the modal
            setModalRoom(true);
    
        } catch (error) {
            console.log(error);
        }
    };
    




    // Check Out Modal
    const [checkOutModal,setCheckOutModal] = useState(false);
    const [checkOutRoom,setCheckOutRoom] = useState(null);
    const handleOpenCheckOutModal = async(bookedRoom) =>{
        setCheckOutRoom(bookedRoom);
        setCheckOutModal(true);
    }


 
    return (
        <div>
            <NotificationProvider/>
            {!isFetching && (isLoading && <PageLoader />)}
            {openPastBook ? (
                <PastBookings close={setOpenPastBook} />
            ) : (
                <div className="w-full">
                    <div className="flex justify-between items-center mb-3">
                        <div className="flex items-center gap-2">
                            <h2 className="text-xl font-semibold tracking-[4px]">
                                ROOMS
                            </h2>
                            <div className="flex items-center border-[1.5px] w-fit rounded-lg overflow-hidden">
                                <button
                                    className={`p-2 border-r-[1.5px] ${
                                        viewChanged === "table"
                                            ? "bg-[#ff7378] text-white"
                                            : "text-[#ff7378]"
                                    }`}
                                    onClick={() => setViewChanged("table")}
                                >
                                    <Table weight="fill" />
                                </button>
                                <button
                                    className={`p-2 border-r-[1.5px] ${
                                        viewChanged === "grid"
                                            ? "bg-[#ff7378] text-white"
                                            : "text-[#ff7378]"
                                    }`}
                                    onClick={() => setViewChanged("grid")}
                                >
                                    <GridFour weight="fill" />
                                </button>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <button
                                className="bg-gray-200 px-4 py-2 rounded-lg flex items-center gap-2"
                                onClick={() => {
                                    setOpenPastBook(true);
                                }}
                            >
                                <ClockCounterClockwise size={18} />
                                Past Bookings
                            </button>
                            {openReq && (
                                <>
                                    {activeComponent === "ConfirmPrice" && (
                                        <ConfirmPrice
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "WebCheckin" && (
                                        <WebCheckin
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent ===
                                        "PreCheckin Early Checkin Request" && (
                                        <EarlyCheckin
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent ===
                                        "PostCheckin Late Checkout Request" && (
                                        <LateCheckout
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Dining" && (
                                        <Dining
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "HouseKeeping" && (
                                        <HouseKeeping
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "WakeUp" && (
                                        <WakeUp
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}{" "}
                                    {activeComponent === "Conference" && (
                                        <ConferenceRoom
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "extendStay" && (
                                        <ExtendStay
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Custom" && (
                                        <Custom
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Restaurant Table" && (
                                        <RestaurantTable
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Get Wifi" && (
                                        <Wifi
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}{" "}
                                    {activeComponent === "Checkout" && (
                                        <Checkout
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}{" "}
                                    {activeComponent ===
                                        "PostCheckin Room Change Request" && (
                                        <RoomChange
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                    {activeComponent === "Spa" && (
                                        <Spa
                                            func={setOpenReq}
                                            selectedRequest={selectedRequest}
                                        />
                                    )}
                                </>
                            )}
                            <div className="relative inline-block">
                                <button
                                    className="bg-gray-200 px-4 py-2 rounded-lg flex items-center gap-2"
                                    onClick={() => setOpenFilter(!openFilter)}
                                >
                                    <Funnel size={18} />
                                    Filter
                                </button>

                                {openFilter && (
                                    <div className="absolute top-full right-0 mt-2 border-[1.5px] rounded-md bg-white text-sm w-96 overflow-hidden z-50">
                                        <div className="flex items-center justify-between bg-[#F2F7FF] px-3 py-2">
                                            <h2 className="font-semibold">
                                                Filters
                                            </h2>
                                            <button
                                                onClick={() =>
                                                    setOpenFilter(false)
                                                }
                                                className="bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                                            >
                                                <X weight="bold" size={15} />
                                            </button>
                                        </div>
                                        <div className="p-3 flex flex-col gap-3">
                                            {/* Booking Number */}
                                            {/* <div>
                                                <label htmlFor="bookingNumber">
                                                    Booking Number
                                                </label>
                                                <select
                                                    className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                                        filters.bookingNumber ===
                                                        ""
                                                            ? "text-gray-500"
                                                            : "text-black"
                                                    }`}
                                                    name="bookingNumber"
                                                    value={
                                                        filters.bookingNumber
                                                    }
                                                    onChange={
                                                        handleFilterChange
                                                    }
                                                >
                                                    <option
                                                        value=""
                                                        className="text-gray-500"
                                                    >
                                                        Choose Booking #s
                                                    </option>
                                                    {data &&
                                                        data.activeBookings &&
                                                        data.activeBookings.map(
                                                            (d, index) => (
                                                                <option
                                                                    key={index}
                                                                    value={
                                                                        d.booked_room_id
                                                                    }
                                                                >
                                                                    {
                                                                        d.booked_room_id
                                                                    }
                                                                </option>
                                                            ),
                                                        )}
                                                </select>
                                            </div> */}

                                            {/* Room Numbers */}
                                            <div>
                                                <label
                                                    htmlFor="roomNumber"
                                                    className="font-medium"
                                                >
                                                    Room Number
                                                </label>
                                                <select
                                                    name="roomNumber"
                                                    className={`border-[1.5px] p-2 rounded-md mt-1 w-full ${
                                                        filters.roomNumber ===
                                                        ""
                                                            ? "text-gray-500"
                                                            : "text-black"
                                                    }`}
                                                    value={filters.roomNumber}
                                                    onChange={
                                                        handleFilterChange
                                                    }
                                                >
                                                    <option value="">
                                                        Choose Room Numbers
                                                    </option>
                                                  
                                                    {data &&
                                                        Array.isArray(
                                                            data?.activeBookings,
                                                        ) &&
                                                        data.activeBookings
                                                            .filter(
                                                                (
                                                                    d,
                                                                    index,
                                                                    self,
                                                                ) =>
                                                                    index ===
                                                                    self.findIndex(
                                                                        (t) =>
                                                                            t.room_no ===
                                                                            d.room_no,
                                                                    ),
                                                            )
                                                            .map((d, index) => (
                                                                <option
                                                                    key={index}
                                                                    value={
                                                                        d.room_no
                                                                    }
                                                                >
                                                                    {d.room_no}
                                                                </option>
                                                            ))}
                                                </select>
                                            </div>
                                            <div>
                                                <label className="font-medium">
                                                    Any Rooms With
                                                </label>
                                                <div className="flex gap-4 px-1 mt-1">
                                                    <div className="flex items-center gap-1.5 w-1/2">
                                                        <input
                                                            type="checkbox"
                                                            value="pendingRequests"
                                                            name="pendingRequests"
                                                            checked={
                                                                filters.pendingRequests
                                                            }
                                                            onChange={
                                                                handleFilterChange
                                                            }
                                                            id="pendingRequests"
                                                        />
                                                        <label htmlFor="pendingRequests">
                                                            Pending Requests
                                                        </label>
                                                    </div>
                                                    <div className="flex items-center gap-1.5 w-1/2">
                                                        <input
                                                            type="checkbox"
                                                            value="ongoingRequests"
                                                            name="ongoingRequests"
                                                            checked={
                                                                filters.ongoingRequests
                                                            }
                                                            onChange={
                                                                handleFilterChange
                                                            }
                                                            id="ongoingRequests"
                                                        />
                                                        <label htmlFor="ongoingRequests">
                                                            Ongoing Requests
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="bg-[#F2F7FF] px-3 py-2 flex items-center justify-between">
                                            <button
                                                className="text-[#ff7378] border-[1.5px] rounded-md px-2 py-1"
                                                onClick={resetFilters}
                                            >
                                                Reset
                                            </button>
                                            <button
                                                className="bg-[#ff7378] px-3 py-1 rounded-md"
                                                onClick={applyFilter}
                                            >
                                                Apply Filter
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* {manageRoom && (
                        <ManageRoom
                            func={setManageRoom}
                            selectedRoom={selectedRoom}
                        />
                    )} */}

                    <div className="flex">
                        {filteredData &&
                            (viewChanged === "grid" ? (
                                <div
                                    className={`grid ${
                                        selectedBookedRoom
                                            ? "w-1/2 lg:grid-cols-2"
                                            : "w-full lg:grid-cols-4"
                                    } grid-cols-1 sm:grid-cols-2  gap-4 h-fit`}
                                >
                                    {Array.isArray(filteredData) &&
                                        filteredData.map((d, index) => (
                                            <div
                                                className={`p-4 bg-white shadow-lg rounded-lg border-2 ${
                                                    selectedBookedRoom?.booked_room_id ===
                                                    d.booked_room_id
                                                        ? "border-green-500 bg-[#d2f3e6]"
                                                        : "border-gray-200"
                                                } text-sm hover:border-green-500 hover:outline-2 cursor-pointer`}
                                                key={d.booked_room_id}
                                                onClick={() =>
                                                    handleItemClick(d)
                                                }
                                            >
                                                <div className="flex justify-between items-center mb-2 text-2xl">
                                                    <h2 className=" text-[#BFC4CC] text-lg">
                                                        Room No.
                                                    </h2>
                                                    <div className="flex items-center gap-1">
                                                        <h2 className="font-semibold text-gray-800">
                                                            {d.room_no}
                                                        </h2>
                                                        <button
                                                        // onClick={() => {
                                                        //     setManageRoom(true);
                                                        //     setSelectedRoom({
                                                        //         bookingId:
                                                        //             d.booking_id,
                                                        //         bookedRoomId:
                                                        //             d.booked_room_id,
                                                        //     });
                                                        // }}
                                                        // onClick={(e) =>
                                                        //     handleManageRoom(
                                                        //         d,
                                                        //         d?.booked_room_id,
                                                        //         e,
                                                        //     )
                                                        // }
                                                        >
                                                            <ArrowUpRight
                                                                weight="bold"
                                                                className="text-[#0B22B2]"
                                                            />
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="space-y-1">
                                                    <div className="flex justify-between items-center border-b-[1.5px] py-1.5">
                                                        <p className="text-gray-500">
                                                            Pending Requests
                                                        </p>
                                                        <span className="text-sm text-white bg-[#FF5A5F] rounded-full px-2 py-0.5">
                                                            {d.pending_requests}
                                                        </span>
                                                    </div>
                                                    <div className="flex justify-between items-center border-b-[1.5px] py-1.5">
                                                        <p className="text-gray-500">
                                                            Ongoing Requests
                                                        </p>
                                                        <span className="text-sm text-white bg-[#0B22B2] rounded-full px-2 py-0.5">
                                                            {d.Ongoing_requests}
                                                        </span>
                                                    </div>
                                                    <div
                                                        className="flex justify-between items-center border-b-[1.5px] py-1.5"
                                                        key={index}
                                                    >
                                                        <p className="text-gray-500">
                                                            Booked Room ID#
                                                        </p>

                                                        <div className="flex items-center space-x-2 w-2/4">
                                                            <span
                                                                className="text-sm font-semibold text-[#FF5A5F] truncate "
                                                                title={
                                                                    d?.booked_room_id
                                                                }
                                                            >
                                                                {d?.booked_room_id}
                                                            </span>
                                                            <button
                                                                onClick={() =>
                                                                    handleCopy(
                                                                        d?.booked_room_id,
                                                                        index,
                                                                    )
                                                                }
                                                                className="text-gray-500 hover:text-blue-500"
                                                                title="Copy to clipboard"
                                                            >
                                                                {copiedId ===
                                                                index ? (
                                                                    <Checks
                                                                        size={
                                                                            16
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <Copy
                                                                        size={
                                                                            16
                                                                        }
                                                                    />
                                                                )}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            ) : (
                                <div className="w-1/2">
                                    <table className="w-full  rounded-2xl overflow-hidden text-sm">
                                        <thead className="bg-[#EEF0FB]">
                                            <tr>
                                                <th className="text-[#0B22B2] font-medium p-3">
                                                    Room / Booking #
                                                </th>
                                                <th className="text-[#0B22B2] font-medium p-3">
                                                    Pending Requests
                                                </th>
                                                <th className="text-[#0B22B2] font-medium p-3">
                                                    Ongoing Requests
                                                </th>
                                                <th className="text-[#0B22B2] font-medium p-3"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(filteredData) &&
                                                filteredData.map((d, index) => (
                                                    <tr
                                                        className={`w-full ${
                                                            selectedBookedRoom?.booked_room_id ===
                                                            d.booked_room_id
                                                                ? "bg-[#E6FFF5]"
                                                                : index % 2 ===
                                                                  0
                                                                ? "bg-white"
                                                                : "bg-[#EEF0FB]"
                                                        }`}
                                                        key={d.booked_room_id}
                                                        onClick={() =>
                                                            handleItemClick(d)
                                                        }
                                                    >
                                                        <td className="text-center p-2 text-2xl font-semibold">
                                                            {d.room_no}
                                                        </td>
                                                        <td className="text-center p-2">
                                                            <span className="text-sm text-white bg-[#FF5A5F] rounded-full px-2 py-0.5">
                                                                {
                                                                    d.pending_requests
                                                                }
                                                            </span>
                                                        </td>
                                                        <td className="text-center p-2">
                                                            <span className="text-sm text-white bg-[#0B22B2] rounded-full px-2 py-0.5">
                                                                {
                                                                    d.Ongoing_requests
                                                                }
                                                            </span>
                                                        </td>
                                                        <td>...</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))}

                        {selectedBookedRoom && (
                            <div className="w-1/2 ml-3 bg-[#96fdd4] rounded-md h-fit sticky top-20">
     
                                <div className="flex justify-center mt-3 mb-0">
                                    <div className="flex justify-end items-center gap-3 w-[95%]">
                                        
                                        {/* Checkout */}
                                        {/* <button
                                            className="text-[#ff7378] rounded-md border-[#F5CCD3] border-[1.5px] bg-white text-sm p-1.5 px-3 hover:bg-[#fae4e7]"
                                            onClick={() =>
                                                handleCheckout(
                                                    selectedBookedRoom,
                                                )
                                            }
                                        >
                                            Checkout
                                        </button> */}

                                        {charges && (
                                            <button
                                                className="mr-auto flex items-center gap-2 text-[#1F7A5A] rounded-md border-[#1F7A5A] border-[1.5px] bg-white text-sm p-1.5 px-3 font-semibold hover:bg-[#EDF9F3]"
                                                onClick={() => setShowAmounts(true)}
                                                type="button"
                                            >
                                                Pending Amounts
                                                <span className="bg-[#1F7A5A] text-white rounded-full px-2 text-[11px] tabular-nums">
                                                    {formatINR(charges.to_collect)}
                                                </span>
                                            </button>
                                        )}

                                        <button
                                            className="text-[#ff7378] rounded-md border-[#F5CCD3] border-[1.5px] bg-white text-sm p-1.5 px-3 hover:bg-[#fae4e7]"
                                            onClick={() =>
                                                 handleOpenCheckOutModal(
                                                    selectedBookedRoom 
                                                ) 
                                            }
                                        >
                                            Checkout
                                        </button>
                                        
                                        {/* <button className="text-[#595E66] rounded-md border-[1.5px] border-[#8f96a3] px-3 py-1.5 text-sm bg-white">
                                                Change Room
                                            </button> */}

                                        <button
                                            className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#0B22B2] text-white text-sm"

                                            // onClick={() => {
                                            //     navigate(
                                            //         `manage-guest/${selectedBookedRoom.booking_id}/${selectedBookedRoom.booked_room_id}`,
                                            //     );
                                            // }}
                                            onClick = {()=>{handleOpenManageRoomModal(selectedBookedRoom.booking_id,selectedBookedRoom.booked_room_id)}}
                                        >
                                            <UserPlus weight="bold" size={17} />
                                            Manage Room
                                        </button>

                                        {/* Close Button */}
                                        <button
                                            onClick={handleCloseDetail}
                                            className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md bg-white"
                                            type="button"
                                        >
                                            <X weight="bold" size={18} />
                                        </button>

                                    </div>
                                </div>
                                <div className="flex justify-center my-0 mb-3 w-full">
                                    <RoomRequestsPanel
                                        requests={roomRequests}
                                        onOpenRequest={handleOpenRequest}
                                    />
                                </div>
                            </div>
                        )}

                        <Outlet context={{ selectedBookedRoom }} />
                    </div>
                </div>
            )}

            {showAmounts && charges && (
                <PendingAmountsModal
                    room={selectedBookedRoom}
                    charges={charges}
                    onClose={() => setShowAmounts(false)}
                />
            )}

            {/* Modal for Manage Rooms is Here */}
            {modalRoom && 
                <ManageRoom
                    modalRoom ={modalRoom}
                    setModalRoom = {setModalRoom}
                    guestData = {guestData}
                    generalData = {generalData}
                />
            }

            {/* Modal for Check Out */}
            {checkOutModal && 
                <CheckOutModal checkOutRoom={checkOutRoom} 
                    checkOutModal = {checkOutModal}
                    setCheckOutModal = {setCheckOutModal}
                    setSelectedBookedRoom = {setSelectedBookedRoom}
                />
            }
            

        </div>
    );
};

export default Rooms;
